module.exports = __webpack_public_path__ + "img/woodgrain.7fe35374.svg";